import { Injectable } from '@angular/core';
import { ParamContext } from '../../../shared/service/param.context';
import { HttpClient, HttpContext } from '@angular/common/http';
import { PlantingPreparation } from '../models/planting-preparation.model';
import { PlantingMetadata } from '../models/planting-metadata.model';
import { PlantingRequest } from '../models/planting-request.model';
import { SearchComposite } from '../../../shared/model/search-composite';
import { EnableLoadingIndicator, EnablePageBlocking, EnableSavingIndicator } from '../../../shared/loading-indicator';

@Injectable({
    providedIn: 'root'
})
export class PlantingPreparationService {

    constructor(private paramContext: ParamContext,
              private http: HttpClient) { }


    getPlantingPreparationData(searchComposite: SearchComposite<any, number>, studyId: number, datasetId: number) {
        const baseUrl = `/bmsapi/crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}`;
        return this.http.post<PlantingPreparation>(`${baseUrl}/datasets/${datasetId}/planting/preparation/search`, searchComposite, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    };

    getMetadata(plantingRequest: PlantingRequest, studyId: number, datasetId: number) {
        const baseUrl = `/bmsapi/crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}`;
        return this.http.post<PlantingMetadata>(`${baseUrl}/datasets/${datasetId}/planting/metadata`, plantingRequest, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    confirmPlanting(plantingRequest: PlantingRequest, studyId: number, datasetId: number, isCommitOnSaving: boolean) {
        const baseUrl = `/bmsapi/crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}`;
        const url = baseUrl + `/datasets/${datasetId}/planting/` + (isCommitOnSaving ? 'confirmed-generation' : 'pending-generation');
        return this.http.post(url, plantingRequest, { context: new HttpContext().set(EnableSavingIndicator, true).set(EnablePageBlocking, true) });
    };

}
